// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__uXEJd","section-1":"style_section-1__6rmD+","content":"style_content__G83CZ","section-2":"style_section-2__yUmJI","section":"style_section__fLdid"};